export function ExpecSortingIndex(field, order) {
    if(field === "Alphabet") {
        if(order === true){
            return `${process.env.GATSBY_ALGOLIA_EXPEC_REPLICA_ALPHA_ASC_INDEX}`;
        }
        return `${process.env.GATSBY_ALGOLIA_EXPEC_REPLICA_ALPHA_DSC_INDEX}`;
    }
    if(field === "Coverage") {
        if(order === true){
            return `${process.env.GATSBY_ALGOLIA_EXPEC_REPLICA_COVERAGE_ASC_INDEX}`;
        }
        return `${process.env.GATSBY_ALGOLIA_EXPEC_REPLICA_COVERAGE_DSC_INDEX}`;
    }
    if(field === "Created") {
        if(order === true){
            return `${process.env.GATSBY_ALGOLIA_EXPEC_REPLICA_CREATED_ASC_INDEX}`;
        }
        return `${process.env.GATSBY_ALGOLIA_EXPEC_REPLICA_CREATED_DSC_INDEX}`;
    }
    if(field === "Updated") {
        if(order === true){
            return `${process.env.GATSBY_ALGOLIA_EXPEC_REPLICA_UPDATED_ASC_INDEX}`;
        }
        return `${process.env.GATSBY_ALGOLIA_EXPEC_REPLICA_UPDATED_DSC_INDEX}`;
    }
}

export const ExpecSortingList = [
    {label:"Alphabet"},
    {label:"Coverage"},
    {label:"Created"},
    {label:"Updated"},
];

